import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { removeFilter } from '../../actions/scenarioCatalogue/filterAction';
import PropTypes from 'prop-types';

class FilterBubbleOption extends Component {
    render() {
        const allFilters = Object.keys(this.props.filters).reduce((filters, filterKey) => {
            if (this.props.filters[filterKey]) {
                this.props.filters[filterKey].forEach(filter => {
                    filters.push({
                        name: filterKey,
                        value: filter
                    });
                });
            }
            return filters;
        }, []);
        const capitalize = (word) => {
            return word.split("_").map((item) => {
                return `${item.charAt(0).toUpperCase()}${item.slice(1)}`;
            }).join(" ")
        }
        return (
            <ul className="filter-bubbles">
                {allFilters.map(filter => {
                    const filterId = _.snakeCase(`filter-${filter.name}-${filter.value}`);
                    return (
                        <li key={filterId}>
                            <span>{capitalize(filter.name)}: </span>
                            {filter.value}
                            <button type="button" onClick={()=> {this.props.dispatch(removeFilter(filter.name, filter.value)); }}>
                                +
                            </button>
                        </li>
                    )
                })}
            </ul>
        );
    }
}
FilterBubbleOption.propTypes={
filters:PropTypes.string,
dispatch:PropTypes.string,
}
FilterBubbleOption.defaultProps= {
filters:[],
dispatch:[],
}

const mapStateToProps = (state) => {
    return{
        filters: state.filters.filters
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }
export default connect(mapStateToProps)(FilterBubbleOption);
